class MainMenu extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;

    this.openToggle = this.openToggle.bind(this);
    this.openSubMenu = this.openSubMenu.bind(this);

    this.hambuger = this.querySelector(".hamburger");
    //this.hambuger.addEventListener("click", this.openToggle);

    this.clickWrapper = this.querySelector(".main-menu__click-wrapper");
    this.clickWrapper.addEventListener("click", this.openToggle);

    this.primaryMenu = this.querySelector(".primary-menu");

    this.label = this.querySelector(".main-menu__label");
    //this.label.addEventListener("click", this.openToggle);

    this.menuItemsWithSubMenus = this.querySelectorAll(
      ".menu-item-has-children"
    );

    this.menuItemsWithSubMenus.forEach((menuItem) => {
      menuItem.addEventListener("click", (e) => {
        // stop if  submenu
        if (
          e.target.parentElement.classList.contains("menu-item-has-children")
        ) {
          e.preventDefault();
        }

        this.openSubMenu(menuItem, e);
      });
    });
  }

  openToggle() {
    this.isOpen = !this.isOpen;
    this.update();
  }

  update() {
    if (this.isOpen) {
      this.classList.add("open");
      // add make the header full width
      document.querySelector("header.main-header").classList.add("menu-open");

      this.label.innerHTML = "Close";

      document.querySelector("body").classList.add("no-scroll");
    } else {
      this.classList.remove("open");
      // close all sub menus
      this.menuItemsWithSubMenus.forEach((menuItem) => {
        menuItem.classList.remove("open");
        document
          .querySelector("header.main-header")
          .classList.remove("menu-open");
      });
      this.label.innerHTML = "Menu";

      document.querySelector("body").classList.remove("no-scroll");
    }
  }

  openSubMenu(menuItem, e) {
    // if has class open, then assume it's a submenu and do nothing
    if (menuItem.classList.contains("open")) {
      return;
    }

    if (menuItem.classList.contains("level-0")) {
      // close all other submenus
      console.log("close all submenus");
      this.menuItemsWithSubMenus.forEach((menuItem) => {
        menuItem.classList.remove("open");
      });
    }
    if (menuItem.classList.contains("level-1")) {
      /// close all level-1 submenus
      console.log("close level-1 submenus");
      const level1MenuItems = this.querySelectorAll(".level-1");
      level1MenuItems.forEach((menuItem) => {
        menuItem.classList.remove("open");
      });
    }

    menuItem.classList.add("open");
  }
}

customElements.define("main-menu", MainMenu);
